const APPLY_EMAIL = "aquavivafoodsuk@gmail.com";

// Edit this list to add or remove openings. An empty list shows a "send us your CV" message.
const OPENINGS = [
  { title: "Delivery Driver", where: "Manchester" },
  { title: "Warehouse Assistant", where: "Trafford Park" },
  { title: "Customer Support Representative", where: "Remote" },
  { title: "Frontend Developer", where: "Hybrid" },
];

const applyLink = (title) =>
  `mailto:${APPLY_EMAIL}?subject=${encodeURIComponent(`Application: ${title}`)}`;

export default function Careers() {
  return (
    <div className="cj">
      <h2 className="cj-title">Careers at Aquaviva Foods</h2>
      <p className="cj-intro">
        We're always looking for passionate, talented people to join our growing team. If you care
        about fresh food, sustainability, and great customer experience, we'd love to hear from you.
      </p>

      <h3 className="cj-subtitle">Current openings</h3>

      {OPENINGS.length === 0 ? (
        <p className="cj-intro">
          There are no open roles right now, but we'd still like to hear from you. Send your CV
          using the details below.
        </p>
      ) : (
        <ul className="cj-list">
          {OPENINGS.map((job) => (
            <li key={job.title} className="cj-job">
              <div>
                <h4>{job.title}</h4>
                <span className="ui-badge">{job.where}</span>
              </div>
              <a href={applyLink(job.title)} className="ui-btn ui-btn--ghost ui-btn--sm">
                Apply by email
              </a>
            </li>
          ))}
        </ul>
      )}

      <div className="cj-apply">
        <h3>How to apply</h3>
        <p>
          Send your CV and cover letter to{" "}
          <a href={`mailto:${APPLY_EMAIL}`}>
            <strong>{APPLY_EMAIL}</strong>
          </a>
          , and tell us which role you're interested in.
        </p>
      </div>
    </div>
  );
}